import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials'
})
export class InitialsPipe implements PipeTransform {
  transform(firstName: string, lastName: string) {
    return (
      (firstName == null ? '' : firstName[0]) +
      (lastName == null ? '' : lastName[0])
    );
  }
}
